import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  server: {
    JWT_SECRET: z
      .string()
      .min(1, 'JWT_SECRET (access token secret) is required'),
    NODE_ENV: z
      .enum(['development', 'test', 'production'])
      .default('development'),
  },
  clientPrefix: 'NEXT_PUBLIC_',
  client: {
    NEXT_PUBLIC_API_BASE_URL: z
      .string()
      .url()
      .min(1, 'NEXT_PUBLIC_API_BASE_URL is required'),
    NEXT_PUBLIC_BASE_URL: z
      .string()
      .url()
      .min(1, 'NEXT_PUBLIC_BASE_URL is required'),
    NEXT_PUBLIC_CONTACT_EMAIL: z
      .string()
      .email()
      .default('support@skill4skill.ca'),
    NEXT_PUBLIC_CONTACT_PHONE: z.string().default('+1 (123) 456 7890'),
    NEXT_PUBLIC_CONTACT_HOURS: z
      .string()
      .default('Monday - Friday, 9am - 5pm (EST)'),
  },
  runtimeEnv: {
    JWT_SECRET: process.env.JWT_SECRET,
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_CONTACT_EMAIL: process.env.NEXT_PUBLIC_CONTACT_EMAIL,
    NEXT_PUBLIC_CONTACT_PHONE: process.env.NEXT_PUBLIC_CONTACT_PHONE,
    NEXT_PUBLIC_CONTACT_HOURS: process.env.NEXT_PUBLIC_CONTACT_HOURS,
  },

  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  emptyStringAsUndefined: true,
});
